import { network } from './network';
import { ListMove } from '../utils/taskListOrder';

/** "Sort: By hand": save where a task was dropped (backend TaskListOrderService); answers the numbers it saved. */
export const moveInTaskList = (semesterId: number, { taskId, after, before }: ListMove) =>
  network.post<{ id: number; listOrder: number }[]>(`/semesters/${semesterId}/tasks/${taskId}/list-order`, {
    after,
    before
  });
